import CoveredEntity from "components/CoveredEntity";
import ThirdPartyAdmin from "components/ThirdPartyAdmin";
import { Field, Formik } from "formik";
import { Col, FormGroup, InputGroup, InputGroupText, Label, Row } from "reactstrap";
import {
  Button,
} from "reactstrap";
import * as Yup from "yup";
import { default as ReactSelect } from "react-select";
import DatePicker from "react-datepicker";
import Calendar from "assets/icon/calendar-icon.svg";
import moment from "moment/moment";
import React, { useState, useEffect } from "react";
import Invoice from "..";
import { LimitedChipsContainer } from "components/Options";
import useContextService from "hooks/useContextService";
import useAxios from "hooks/useAxios";
import { Option}from 'components/Options'; 
import { cloneDeep } from "lodash";
import Select from "react-select";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import reset from "assets/icon/reset.svg";
import searchicon from "assets/icon/search.svg";


const validationSchema = Yup.object({
  thirdPartyAdminID: Yup.string().required("Third Party Administrator is required"),
});

let hasDatePopupOpen = false;
let endingyear;
let StartingMonth;
let endingMonth;

const initialValues = {
  thirdPartyAdminID: '',
  coveredEntityID: '',
  month:'',
  year:'',
};

let ceData = [];
let pharmacyData =[];

const InvoiceSearch = (props) => {
  const {
    states: { Invoice },
    setStates,
    resetStates,
  } = useContextService();
  const { onSearch, onReset} = props;
  const[ceDatalist,setCeDatalist]=useState([]);
  const [selectedOption, setOptionSelected] = useState({ optionSelected: '-1' });
  const [selectedOpt, setOptSelected] = useState({ optSelected: '-1' });
  const API = useAxios();
  const [selectedyear, setSelectedYear] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [monthid, setmonth] = useState(endingMonth);
  const [yearvalue, setyear] = useState(endingyear);
  const [maxmont, setmaxmonth] = useState(new Date());
  const[selectedCE,setSelectedCE]=useState(null);
  const[thirdPartyAdminID,setTpaID]=useState('');
  const[selectedTpa,setSelectedTpa]=useState({});
   const[ceList,setCEList]=useState([]);
   const[searchCEterm,setSearchCEterm]=useState('');
  const [isMonthdisable, setIsMonthDisable] = useState(true);
  const [ceLoading, setCeLoading] = useState(false);
  // const [state, updateStates] = useState({
  //   selectedCoveredEntity: {},
  //   loading: false,
  // });

  const { thirdPartyAdmin, searchTerms,coveredEntity,wholesaler,orderStatus,pharmacy} = Invoice;
  const {
    coveredEntityID,
    pharmacyID,
    startDate,
    invoicenumber,
    poNumber,
    wholesalerID,
    endDate,
    orderStatusID,
    ceIds
  } = searchTerms;
  const { tenantID } = thirdPartyAdmin;
  let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: '',
    order: '',
    filters: [],
  };

  const updateStates = (Invoice) => {
    setStates('Invoice', Invoice);
  };

  useEffect(() => {
    Invoice.thirdPartyAdmin={};
    Invoice.coveredEntity=null;
    resetStates('Invoice');
  }, []);

  const formatMonth = (date) => {
    setSelectedDate();
    if (!date) return "";
    setSelectedDate(date);
    const options = { month: "long" };
    const month = moment(new Date(date)).format("MM");
    const monthint = parseInt(month);
    setmonth(monthint);
  };

  const handelYear = (date) => {
    if (!date) return "";
    setSelectedDate();
    setSelectedYear(date);
    setIsMonthDisable(false);
    const year = moment(new Date(date)).format("YYYY");
    setyear(year);
    let currentyear = new Date().getFullYear();
    let yearvalue = parseInt(year);
    if (currentyear === yearvalue) {
      //fetchStartingYearMonth();
      //fetchGetEndingYearMonth();
      setmaxmonth(new Date());
      //setSelectedDate(new Date());
    } else {
      let monthdata = new Date(currentyear, 12, 1);
      setmaxmonth(monthdata);
      // setSelectedDate(monthdata)
      setmonth(12);
    }
  };

  const findCE = async (value) => {
    setSearchCEterm(value);
  };

  const handleThirdPartyAdminChange = async (value,setFieldValue, tpa) => {
    setSelectedTpa({});
    setCEList([]);
    setSelectedCE(null);
    setOptionSelected({ optionSelected: '-1' });
    Invoice.searchTerms.ceIds = {};
    setCeDatalist([]);
    pharmacyData=[];
    ceData=[];
    setSelectedYear("");
    setSelectedDate("");
    setOptSelected({optSelected:'-1'});
    const { thirdPartyAdminID } = tpa;
    fetchCoveredEntities(thirdPartyAdminID);
    if (tpa) {
      const { thirdPartyAdminID } = tpa;
      Invoice.coveredEntity= '';
      Invoice.searchTerms.coveredEntityID = '';
      // Invoice.pharmacy = '';
      // Invoice.searchTerms.pharmacyID = '';
      Invoice.thirdPartyAdmin = tpa;
      Invoice.searchTerms.thirdPartyAdminID = thirdPartyAdminID;
      setFieldValue('thirdPartyAdminID', thirdPartyAdminID);
      setFieldValue('thirdPartyAdmin',tpa);
      setSelectedTpa(tpa);
      setTpaID(thirdPartyAdminID);
      setCEList([]);
      setSelectedCE(null);
      // fetchCoveredEntities(thirdPartyAdminID);
    } else {
      Invoice.coveredEntity = '';
      Invoice.searchTerms.coveredEntityID = '';
      // Invoice.pharmacy = '';
      // Invoice.searchTerms.pharmacyID = '';
      Invoice.thirdPartyAdmin = {};
      Invoice.searchTerms.thirdPartyAdminID = '';
      setFieldValue('thirdPartyAdminID', '');
      setSelectedTpa({});
      setTpaID('');
      setSelectedCE(null);
      ceData = [];
    }
    updateStates(Invoice);
  };

  const handleCEChange = (selected) => {
    if(selected.length !==0)
    {
      setOptSelected({
        optSelected: -1
      });
    }
    // if(selected.length ===0){
    //   fetchPharmacyNamesByTpaID(thirdPartyAdminID);
    // }
    // pharmacyData = [];
    setOptionSelected({
      optionSelected: selected
    });
    Invoice.searchTerms.ceIds = selected;
    updateStates(Invoice);
    // fetchPharmacyNames(selected);
  };

  // const fetchCoveredEntities = async (thirdPartyAdminID) => {
  //   try {
  //     const { data } = await API.get(
  //       `GWConfig/coveredentity/CElist/${thirdPartyAdminID}`,
  //       {
  //         hasDefaultURL: true,
  //         hideLoader: true,
  //       }
  //     );
  //     setCEList(data);
  //     setSearchCEterm('');
  //   } catch (error) {
  //     console.log(error.message);
  //   }
  // };

  const fetchCoveredEntities = async (thirdPartyAdminID) => {
    setCeDatalist([]);
    ceData = [];
    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/CElist/${thirdPartyAdminID}`,
        {
          hasDefaultURL: true,
          hideLoader: true,
        }
      );
      if(data){
        for (var x in data) {
          ceData.push({ "value": data[x].id, "label": data[x].description });
        }
        setCeDatalist(ceData);
      }

    } catch (error) {
      console.log(error.message);
    }
  };

  const onSelectCE = (entity,setFieldValue) => {
    if (entity) {
      setFieldValue('coveredEntityID', entity.id);
      setSelectedCE(entity);
    } else {
      setFieldValue('coveredEntityID','');
      setSelectedCE(null);
    }
  };

  // const handleSubmit = async (val, actions) => {
  //   const { setSubmitting } = actions;
  //   const values = cloneDeep(val);
  //   values.year = selectedyear
  //     ? moment(new Date(selectedyear)).format("YYYY")
  //     : 0;
  //   values.month = selectedDate
  //     ? moment(new Date(selectedDate)).format("MM")
  //     : 0;
  //   await onSearch(values);
  //   setSubmitting(false);
  // };

  const handleSubmit = async (val, actions) => {
    let coveredEntityIDS = [];
    for (var x in selectedOption.optionSelected) {
      var rw = selectedOption.optionSelected[x];
      coveredEntityIDS.push(rw.value);
    }
    const { setSubmitting } = actions;
    const values = cloneDeep(val);
    values.year = selectedyear
      ? moment(new Date(selectedyear)).format("YYYY")
      : 0;
    values.month = selectedDate
      ? moment(new Date(selectedDate)).format("MM")
      : 0;
    if(thirdPartyAdminID) values.thirdPartyAdminID;
    if (coveredEntityIDS > [0]) values.coveredEntityIDS = coveredEntityIDS;
    Invoice.search.currentPage = 1;
    updateStates(Invoice);
    await onSearch(values);
    setSubmitting(false);
  };

  const handleReset = (props) => {
    setTpaID('');
    setSelectedTpa({});
    setIsMonthDisable(true);
    setCEList([]);
    setSelectedCE(null);
    setSelectedYear("");
    setSelectedDate("");
    const { resetForm, setSubmitting } = props;
    resetForm();
    onReset();
    resetForm();
    onReset();
    resetStates('Invoice');
    setOptionSelected({ optionSelected: '-1' });
    Invoice.searchTerms.ceIds = {};
    setCeDatalist([]);
    pharmacyData=[];
    ceData=[];
    setOptSelected({optSelected:'-1'});
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }

    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };


  return (
    <>
      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize={true}
        children={(props) => {
          const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
          return (
            <div>
              <h5 className="f-16 text-primary font-weight-700">Invoice</h5>
              <Row>
                <Col md={2} sm={3} xs={6}>
                  {" "}
                  <FormGroup>
                    <Label for="tpa">Third Party Administrator</Label>
                    <ThirdPartyAdmin
                      value={thirdPartyAdminID}
                      name='thirdPartyAdminID'
                      onChange={(value, tpa) =>
                      handleThirdPartyAdminChange(value,setFieldValue,tpa)
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={3} sm={3} xs={6}>
                  <FormGroup>
                    <Label for="coveredEntity">Covered Entity</Label>
                    {/* <Select
                                   id="coveredEntityID"
                                   //className="form-field-large inner-shadow-field required" //npi-name
                                   classNamePrefix="select"
                                   IndicatorSeparator
                                   isSearchable={true}
                                   isLoading={ceLoading}
                                   placeholder="Enter OPAID Or CE Name"
                                   isClearable={true}
                                   name="color"
                                   options={ceList}
                                   value={selectedCE}
                                   inputValue={searchCEterm}
                                   onInputChange={findCE}
                                   onChange={(value) =>onSelectCE(value,setFieldValue)}
                                   getOptionLabel={(option) => option.description}
                                   getOptionValue={(option) => option.id}
                                   // isDisabled={!tenantID}
                                   components={{
                                     DropdownIndicator: () => null,
                                     IndicatorSeparator: () => null,
                                   }}
                                   styles={{
                                     menu: (provided) => ({
                                       ...provided,
                                       zIndex: 99,
                                     }),
                                   }}
                                 /> */}
                    <ReactSelect
                      name='ceDatalist'
                      options={ceDatalist}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      optionSelected={true}
                      components={{
                        Option, ValueContainer: LimitedChipsContainer
                      }}
                      isSearchable="true"
                      onChange={handleCEChange}
                      value={selectedOption.optionSelected}
                      className='claim_info'
                      maxMenuHeight={220}
                      styles={{
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 99,
                        }),
                        option: (provided) => ({
                          ...provided,
                          display: 'flex',
                          alignItems: 'flex-start',
                        })
                      }}
                    />
                  </FormGroup>
                </Col>

                <Col md={2} sm={3} xs={6}
                  className="datepicker_info">
                  <FormGroup>
                    <Label for="yearID">Year</Label>
                    <div id="text">
                      <InputGroup onMouseLeave={handleMouseLeave}>
                        <DatePicker
                          id="startDate"
                          selected={selectedyear}
                          onChange={(date) => handelYear(date)}
                          onKeyDown={(e) => e.preventDefault()}
                          dateFormat="yyyy"
                          maxDate={new Date()}
                          autoComplete="off"
                          showYearPicker
                        />
                        <InputGroupText
                          onClick={() => handleDateClick("startDate")}
                        >
                          <img src={Calendar} alt="" />
                        </InputGroupText>
                      </InputGroup>
                    </div>
                  </FormGroup>
                </Col>
                <Col md={2}
                  sm={3}
                  xs={6}
                  className="datepicker_info">
                  <FormGroup>
                    <Label>Month</Label>
                    <div id="text">
                      <InputGroup onMouseLeave={handleMouseLeave}>
                        <DatePicker
                          id="endDate"
                          onKeyDown={(e) => e.preventDefault()}
                          selected={selectedDate}
                          onChange={(date) => formatMonth(date)}
                          maxDate={maxmont}
                          dateFormat="MMMM"
                          autoComplete="off"
                          showMonthYearPicker
                          style={{ width: "150px" }}
                          disabled={isMonthdisable}
                        />
                        <InputGroupText
                          onClick={() => handleDateClick("endDate")}
                        >
                          <img src={Calendar} alt="" />
                        </InputGroupText>
                      </InputGroup>
                    </div>
                  </FormGroup>
                </Col>
            
              </Row>
              <Row className="d-flex justify-content-end">
                    <Col md="auto" className="pt-4 mt-1">
                  <Label>{""}</Label>
                  <Button
                    disabled={isSubmitting}
                    onClick={handleSubmit}
                    color="primary"
                    className="search"
                  >
                     <span className="right_5">
                                        <img src={searchicon} alt="" />
                                      </span>{" "}
                    Search
                  </Button >
                  <Button color="primary" className="reset" onClick={() => handleReset(props)}>
                    <span className="right_5">
                                       <img src={reset} alt="" />
                                     </span>{" "}
                    Reset
                  </Button>
                </Col>
              </Row>
            </div>
          )
        }}
      >
      </Formik>
    </>
  )
}
export default InvoiceSearch



